var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "MessageArchive",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-message-archive","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M231.5 105.8V63h-12.1V30.6h-70.5c-2.5 0-4.5 2-4.5 4.5s2 4.5 4.5 4.5h61.5V63h-37.2c-2.5 0-4.5 2-4.5 4.5s2 4.5 4.5 4.5h49.4v33.8h-58.8l-12.1 13.9H95.3l-10.4-13.9H26.5V72h47.3c2.5 0 4.5-2 4.5-4.5s-2-4.5-4.5-4.5H36.9V39.6h60.4c2.5 0 4.5-2 4.5-4.5s-2-4.5-4.5-4.5H27.8V63H17.4v42.8H4.5l24 144.2h195.7l21.3-144.2h-14zm-15 135.2H36.2l-21-126.2h65.2l10.4 13.9h65l12.1-13.9h67.2L216.5 241z"/>
  <path d="M100.5 71c-1.7-1.8-4.6-1.9-6.4-.2-1.8 1.7-1.9 4.6-.2 6.4l25.4 26.9c.9.9 2 1.4 3.3 1.4 1.3 0 2.5-.5 3.3-1.5l25.5-28c1.7-1.8 1.5-4.7-.3-6.4-1.8-1.7-4.7-1.5-6.4.3l-17.6 19.3V4.5c0-2.5-2-4.5-4.5-4.5s-4.5 2-4.5 4.5v85.3L100.5 71z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/message-archive.svg